export default "__VITE_ASSET__BN9SIyUq__"